/**
 * podravka.io
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.7.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BadRequestError from '../model/BadRequestError';
import ForbiddenError from '../model/ForbiddenError';
import ImageConfigAspectRatioCreate from '../model/ImageConfigAspectRatioCreate';
import ImageConfigAspectRatioList from '../model/ImageConfigAspectRatioList';
import ImageConfigAspectRatioRead from '../model/ImageConfigAspectRatioRead';
import ImageConfigVariationCreate from '../model/ImageConfigVariationCreate';
import ImageConfigVariationList from '../model/ImageConfigVariationList';
import ImageConfigVariationRead from '../model/ImageConfigVariationRead';
import ImageConfigVariationUpdate from '../model/ImageConfigVariationUpdate';
import NotAcceptableError from '../model/NotAcceptableError';
import NotFoundError from '../model/NotFoundError';
import UnauthorizedError from '../model/UnauthorizedError';

/**
* ImageConfig service.
* @module api/ImageConfigApi
* @version 1.7.2
*/
export default class ImageConfigApi {

    /**
    * Constructs a new ImageConfigApi. 
    * @alias module:api/ImageConfigApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createImageConfigAspectRatio operation.
     * @callback module:api/ImageConfigApi~createImageConfigAspectRatioCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ImageConfigAspectRatioRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a ImageConfigAspectRatio resource.
     * @param {module:model/ImageConfigAspectRatioCreate} imageConfigAspectRatio Required properties are: * name * ratio 
     * @param {module:api/ImageConfigApi~createImageConfigAspectRatioCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ImageConfigAspectRatioRead}
     */
    createImageConfigAspectRatio(imageConfigAspectRatio, callback) {
      let postBody = imageConfigAspectRatio;
      // verify the required parameter 'imageConfigAspectRatio' is set
      if (imageConfigAspectRatio === undefined || imageConfigAspectRatio === null) {
        throw new Error("Missing the required parameter 'imageConfigAspectRatio' when calling createImageConfigAspectRatio");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ImageConfigAspectRatioRead;
      return this.apiClient.callApi(
        '/images/config/aspect-ratios', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createImageConfigVariation operation.
     * @callback module:api/ImageConfigApi~createImageConfigVariationCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ImageConfigVariationRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a ImageConfigVariation resource.
     * @param {module:model/ImageConfigVariationCreate} imageConfigVariation Required properties are: * name * method 
     * @param {module:api/ImageConfigApi~createImageConfigVariationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ImageConfigVariationRead}
     */
    createImageConfigVariation(imageConfigVariation, callback) {
      let postBody = imageConfigVariation;
      // verify the required parameter 'imageConfigVariation' is set
      if (imageConfigVariation === undefined || imageConfigVariation === null) {
        throw new Error("Missing the required parameter 'imageConfigVariation' when calling createImageConfigVariation");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ImageConfigVariationRead;
      return this.apiClient.callApi(
        '/images/config/variations', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteImageConfigAspectRatio operation.
     * @callback module:api/ImageConfigApi~deleteImageConfigAspectRatioCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the ImageConfigAspectRatio resource.
     * @param {String} id 
     * @param {module:api/ImageConfigApi~deleteImageConfigAspectRatioCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteImageConfigAspectRatio(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteImageConfigAspectRatio");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/images/config/aspect-ratios/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteImageConfigVariation operation.
     * @callback module:api/ImageConfigApi~deleteImageConfigVariationCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the ImageConfigVariation resource.
     * @param {String} id 
     * @param {module:api/ImageConfigApi~deleteImageConfigVariationCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteImageConfigVariation(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteImageConfigVariation");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/images/config/variations/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getImageConfigAspectRatio operation.
     * @callback module:api/ImageConfigApi~getImageConfigAspectRatioCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ImageConfigAspectRatioRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a ImageConfigAspectRatio resource.
     * @param {String} id 
     * @param {module:api/ImageConfigApi~getImageConfigAspectRatioCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ImageConfigAspectRatioRead}
     */
    getImageConfigAspectRatio(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getImageConfigAspectRatio");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = ImageConfigAspectRatioRead;
      return this.apiClient.callApi(
        '/images/config/aspect-ratios/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getImageConfigAspectRatioList operation.
     * @callback module:api/ImageConfigApi~getImageConfigAspectRatioListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ImageConfigAspectRatioList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of ImageConfigAspectRatio resources.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/ImageConfigApi~getImageConfigAspectRatioListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ImageConfigAspectRatioList>}
     */
    getImageConfigAspectRatioList(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [ImageConfigAspectRatioList];
      return this.apiClient.callApi(
        '/images/config/aspect-ratios', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getImageConfigVariation operation.
     * @callback module:api/ImageConfigApi~getImageConfigVariationCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ImageConfigVariationRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a ImageConfigVariation resource.
     * @param {String} id 
     * @param {module:api/ImageConfigApi~getImageConfigVariationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ImageConfigVariationRead}
     */
    getImageConfigVariation(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getImageConfigVariation");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = ImageConfigVariationRead;
      return this.apiClient.callApi(
        '/images/config/variations/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getImageConfigVariationList operation.
     * @callback module:api/ImageConfigApi~getImageConfigVariationListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ImageConfigVariationList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of ImageConfigVariation resources.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/ImageConfigApi~getImageConfigVariationListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ImageConfigVariationList>}
     */
    getImageConfigVariationList(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [ImageConfigVariationList];
      return this.apiClient.callApi(
        '/images/config/variations', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateImageConfigVariation operation.
     * @callback module:api/ImageConfigApi~updateImageConfigVariationCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ImageConfigVariationRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the ImageConfigVariation resource.
     * @param {String} id 
     * @param {module:model/ImageConfigVariationUpdate} imageConfigVariation Instances will be appended to existing ones.
     * @param {module:api/ImageConfigApi~updateImageConfigVariationCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ImageConfigVariationRead}
     */
    updateImageConfigVariation(id, imageConfigVariation, callback) {
      let postBody = imageConfigVariation;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateImageConfigVariation");
      }
      // verify the required parameter 'imageConfigVariation' is set
      if (imageConfigVariation === undefined || imageConfigVariation === null) {
        throw new Error("Missing the required parameter 'imageConfigVariation' when calling updateImageConfigVariation");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = ImageConfigVariationRead;
      return this.apiClient.callApi(
        '/images/config/variations/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
